import styled from 'styled-components'
import { Col } from '@navent-jobs/ui-kit/components/grid'
import { Link } from '@navent-jobs/ui-kit/components/link'

export const ASalariosContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ background }) => `white url(${background}) no-repeat right`};
  background-origin: content-box;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 12px;
  margin: 16px 0 24px 0;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    flex-direction: column;
    padding: 16px;
    margin: 0 0 22px 0;
  }
`

export const CustomCol = styled(Col)`
  align-self: center;
`

export const Heading = styled('div')`
  display: flex;
  margin-bottom: 12px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    margin-bottom: 0;
    align-self: center;
    border-right: 1px solid ${({ theme }) => theme.colors.grey8};
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    margin-bottom: 16px;
    align-self: flex-start;
    border-right: none;
  }
`

export const ASalariosContent = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.primary.normal};
  font-weight: 600;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    flex-direction: row;
    align-self: center;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    line-height: 32px;
    align-self: auto;
  }
`

export const Text = styled('p')`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.grey84};
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  margin-bottom: 12px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    display: block;
    align-self: center;
    margin-bottom: 0;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    align-self: flex-start;
  }
`

export const Puesto = styled('span')`
  color: ${({ theme }) => theme.colors.grey84};
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    font-size: 16px;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    font-size: 18px;
  }
`

export const LinkASalarios = styled(Link)`
  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    align-self: center;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    align-self: flex-end;
  }
`
